// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../public/static/fonts/Nord-Light.ttf", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Global variables definition */
:root {
  /* Responsive font sizes */
  --step--2: clamp(0.69rem, calc(0.66rem + 0.18vw), 0.8rem);
  --step--1: clamp(0.83rem, calc(0.78rem + 0.29vw), 1rem);
  --step-0: clamp(1rem, calc(0.91rem + 0.43vw), 1.25rem);
  --step-1: clamp(1.2rem, calc(1.07rem + 0.63vw), 1.56rem);
  --step-2: clamp(1.44rem, calc(1.26rem + 0.89vw), 1.95rem);
  --step-3: clamp(1.73rem, calc(1.48rem + 1.24vw), 2.44rem);
  --step-4: clamp(2.07rem, calc(1.73rem + 1.7vw), 3.05rem);
  --step-5: clamp(2.49rem, calc(2.03rem + 2.31vw), 3.82rem);
}

/* Reusable classes */

.ff-nord {
  font-family: "Nord", sans-serif !important;
}

.font--2 {
  font-size: var(--step--2) !important;
}
.font--1 {
  font-size: var(--step--1) !important;
}
.font-0 {
  font-size: var(--step-0) !important;
}
.font-1 {
  font-size: var(--step-1) !important;
}
.font-2 {
  font-size: var(--step-2) !important;
}
.font-3 {
  font-size: var(--step-3) !important;
}
.font-4 {
  font-size: var(--step-4) !important;
}
.font-5 {
  font-size: var(--step-5) !important;
}

* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
  font-family: "Montserrat", sans-serif;
}


html {
  scroll-behavior: smooth;
  overflow-x: hidden !important;
  background: linear-gradient(to right, #12121E, #242424);

}
body {
  zoom: 65%;
  width: 100%;
  height: 100%;
  font-family: poppins;
  background: linear-gradient(to right, #12121E, #242424);
  background-position: center;
  overflow-x: hidden !important;
}


.App {
  overflow-x: hidden;
  width: 100%;
  background: linear-gradient(to right, #12121E, #242424);

}

@font-face {
  font-family: "Nord";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) format("truetype");
  font-weight: normal;
  font-style: normal;
}
/*++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++PC+++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++*/
/*--------------------------------------------------------------------Navbar--------------------------------------------------------------------------------*/
@keyframes scrolling {
  0% {
    overflow: hidden;
    animation-delay: 4s;
  }
  50% {
    animation-delay: 4s;
  }
  100% {
    animation-delay: 4s;
    overflow: visible;
  }
}

@keyframes gradientMove {
  0% {
    background-position: 0 0;
  }
  50% {
    background-position: 0 50%;
  }
  100% {
    background-position: 100% 0;
  }
}

@keyframes slideFromBelow {
  0% {
    opacity: 0;
    transform: translateY(50%);
  }
  100% {
    opacity: 1;
    transform: translateY(0);

  }
}

@keyframes slideFromBelowDesktop {
  0% {
    transform: translateY(50%);
    opacity: 0;

  }
  100% {
    transform: translateY(-50%);
    opacity: 1;

  }
}

@keyframes slideFromLeft {
  0% {
    transform: translateX(-100%);
    opacity: 0;
  }
  100% {
    transform: translateX(-20%);
    opacity: 1;
  }
}
@keyframes slideFromLeftDesktop {
  0% {
    transform: translateX(-100%);
    opacity: 0;
  }
  100% {
    transform: translateX(90%);
    opacity: 1;
  }
}

.navbar-nav {
  display: flex;
  flex-wrap: nowrap;
}

.nav-item {
  padding: 0 10px;
}

.navbar-custom {
  background-color: transparent !important;
  z-index: 2;
}

.navbar-custom .navbar-brand-custom {
  color: white;
  font-size: 1.5rem; /* Default font size */
  text-decoration: none;
  margin-left: 1.4rem;
  margin-right: 1.4rem;
  font-family: "Prompt", sans-serif;
  font-weight: 300;
  font-style: normal;
}

.navbar-custom .navbar-brand-custom:hover,
.navbar-custom .navbar-brand-custom.active {
  color: #FC5404;
  font-weight: 600;

}

@media (max-width: 768px) {
  .navbar-custom .navbar-brand-custom {
    font-size: 0.8rem;
    margin-left: 0.8rem;
    margin-right: 0.8rem;
  }

  button.btn-orange {
    margin-bottom: 30px;
    background-color: #FC5404;
    color: white;
    padding: 13px 30px;
    border: none;
    border-radius: 5px;
    font-weight: bold;
    cursor: pointer;
    font-size: 1rem;
    font-family: "Prompt", sans-serif;
    font-weight: 500;
    font-style: normal;
    z-index: 1000;
  }
  
  .btn-orange:hover {
    background-color: rgb(160, 84, 22);
  }
  .social-buttons{
    z-index: 1000;
  }
  img.socialLogo{
    z-index: 1000;
  }

  .animated-image-container {
    position: absolute;
    left: 23%;
    top: 30%;
    transform: translate(-50%, -50%);
    width: 80vw;
    max-width: 300px;
  }
  .animated-image-container-knowledge {
    position: absolute;
    left: -20%;
    top: 30%;
    transform: translate(-50%, -50%);
    width: 80vw;
    max-width: 300px;
  }
  .animated-image-container-insights {
    position: absolute;
    left: -20%;
    top: 30%;
    transform: translate(-50%, -50%);
    width: 80vw;
    max-width: 300px;
  }
  .animated-image-container-simplicity {
    position: absolute;
    left: 40%;
    top: 30%;
    transform: translate(-50%, -50%);
    width: 160vw;
    max-width: 600px;
    margin-left: 10%;
  }
  .animated-image-container-decode {
    top: 10%;
    left: -10%;
    position: relative;
    margin-bottom: 70vh;

  }
  .animated-image-container-empower {
    position: absolute;
    left: -5%;
    top: 1%;
    width: 135vw;
    max-width: 600px;
  }

  .animated-image {
    width: 210%;
    left: 50%;
    animation: slideFromBelow 1s forwards;
    z-index: 2;
    margin-top: -50px;
  }
  img.animated-image.image-knowledge{
    width: 400%;
    left: 25%;
    animation: slideFromBelow 1s forwards;
  }
  img.animated-image.image-insights{
    width: 400%;
    left: 20%;
    animation: slideFromBelow 1s forwards;
  }
  img.animated-image.image-simplicity{
    left: 20%;
    width: 50%;
  }
  img.animated-image.image-simplicity2{
    left: 140%;
    width: 40%;
  }


  .image-empower{
    left: 23%;
    width: 70%;
    margin-top: 9%;
    position: absolute;
    z-index: 2;   
  }
  .image-empower2{
    left: 50%;
    width: 50%;
    margin-left: 100px;
    margin-top: 35%;
    position: absolute; 
    z-index: 1; 
  }
  .image-empower3{
    left: 60%;
    margin-right: 500px;
    width: 50%;
    margin-top: 35%;
  }


  .image-decode{
    position: absolute;
    left: -12rem;
    width: 50rem;
    top: -4rem;
  }
  .image-decode2{
    position: absolute;
    left: -14rem;
    width: 50rem;
    top: -4rem;
  }
  .image-decode3{
    position: absolute;
    left: -9rem;
    width: 50rem;
    top: -5rem;
  }
  .image-decode4{
    position: absolute;
    left: -12rem;
    width: 50rem;
    top: -4rem;
  }
  h1.text-center.text-lg-left.font-weight-bold.text-white{
    animation: slideFromBelow 1s forwards;
    font-size: 1.3rem;
    margin-top: 50px;
    font-family: "Unbounded", sans-serif;
    font-optical-sizing: auto;
    font-weight: 600;
    font-style: normal;
  }
  p.text-center.text-lg-left.subText{
    animation: slideFromBelow 1s forwards;
    margin-bottom: 30px;
    margin-top: 15px;
    color: #B3B9CF;
    font-size: 0.9rem;
    font-weight: 700;
    width: 420px;
    margin-left: auto;
    margin-right: auto;

  }
  .socialLogo{
    width: 3.1rem;
    height: 3.1rem;
    animation: slideFromBelow 1s forwards;
    margin-bottom: 50px;
    z-index: 1000;
  }
  .socialText{
    margin-top: 100px;
    font-size: 1rem;
    animation: slideFromBelow 1s forwards;
  }
  div.justify-content-center.indicator-container {
    display: flex;
    justify-content: center;
    align-items: center; /* Added for vertical centering */
    background-color: #85899F80;
    width: 65%;
    padding: 0px 1px;
    border-radius: 6%;
    z-index: 1000;
    position: absolute;
    top: 95%;
    left: 50%;
    transform: translateX(-50%); /* Added for horizontal centering */
    min-height: 20px;
  }
  .dot-content {
    width: 8px; /* Adjust width and height as needed */
    height: 8px;
    border: 1px white solid; /* Optional for testing purposes, remove later */
    background-color: white; /* Avoids unexpected background */
    border-radius: 50%;
    margin: 15px 0.9rem;
  }
  div.dot {
    width: 5px; /*dot-content works, this not*/
    height: 5px;
    background-color: #A6ACC4;
    border-radius: 50%;
    margin: 0 8px;
  }
  .indicator-container > .dot.active {
    transform: scale(2);
  }

  a.dot.active div.dot-content{
    margin-left: 0.8rem;
    margin-right: 0.8rem;
  }


  
}
.root-container {
  overflow-x: scroll;
  overflow-y: hidden;
  white-space: nowrap;
  -webkit-overflow-scrolling: touch; /* Enable smooth scrolling on iOS */
}

@media (min-width: 768px) {
  .container {
    display: flex;
    transition: transform 0.5s ease;
  }

  .navbar-custom .navbar-brand-custom {
    font-size: 1.8rem;
    margin-left: 4vw;
    margin-right: 4vw;
  }
  
  /* Adjust the positioning of the components */
  .container > div {
    flex: 0 0 100%; /* Ensure each component takes full width */
  }
  .root-container {
    overflow-x: scroll;
    overflow-y: hidden;
    white-space: nowrap;
    -webkit-overflow-scrolling: touch; /* Enable smooth scrolling on iOS */
  }
  
  button.btn-orange {
    background-color: #FC5404;
    color: white;
    padding: 13px 30px;
    border: none;
    border-radius: 5px;
    font-weight: bold;
    cursor: pointer;
    font-size: 1.5rem;
    font-family: "Prompt", sans-serif;
    font-weight: 500;
    font-style: normal;
    z-index: 1000;
  }
  
  .btn-orange:hover {
    background-color: rgb(160, 84, 22);
  }

  .col-lg-8.offset-lg-2 {
    margin-left: -25rem;
    margin-top: 12rem;
  }
  .animated-image {
    margin-top: -35rem;
    position: absolute;
    width: 135%;
    left: -10%;
    animation: slideFromLeftDesktop 1s forwards;
  }
  .animated-image-container-knowledge {
    position: absolute;
    left: -80%;
    top: -15%;
  }
  .animated-image-container-insights {
    position: absolute;
    left: -60%;
    top: -25%;
  }
  .animated-image-container-decode {
    top: -20%;
    left: -50%;
  }
  .animated-image-container-simplicity {
    top: 20%;
  }
  .animated-image-container-empower {
    top: -100%;
    left: -35%;
  }
  .image-knowledge{
    width: 190%;
  }
  .image-insights{
    left: -20%;
    width: 170%;
  }
  .image-simplicity{
    left: 80%;
    width: 50%;
  }
  .image-simplicity2{
    left: 140%;
    width: 40%;
  }

  .image-empower{
    left: 120%;
    width: 60%;
    z-index: 3;
    margin-top: -15%;
  }
  .image-empower2{
    left: 160%;
    width: 50%;
    margin-top: -1%;
  }
  .image-empower3{
    left: 110%;
    width: 50%;
    margin-top: -1%;
  }
  .image-decode{
    left: -15rem;
    width: 90rem;
    top: 7rem;
    z-index: 3;
  }
  .image-decode2{
    top: 9rem;
    left: -19rem;
    width: 90rem;
  }
  .image-decode3{
    left: -10rem;
    top: 5rem;
    width: 90rem;
  }
  .image-decode4{
    left: -14rem;
    top: 7rem;
    width: 90rem;
  }

  h1.text-center.text-lg-left.font-weight-bold.text-white{
    animation: slideFromBelowDesktop 1s forwards;
    font-family: "Unbounded", sans-serif;
    font-optical-sizing: auto;
    font-weight: 600;
    font-style: normal;
    font-size: 2.1rem;
  }
  h2.text-center.mb-4.font-weight-bold.text-white.socialText{
    font-family: "Unbounded", sans-serif;
    font-weight: 600;
    font-style: normal;
  }


  .socialLogo{
    width: 4.5rem;
    height: 4.5rem;
    animation: slideFromBelowDesktop 1s forwards;
    margin-top: 5rem;
  }
  .socialText{
    margin-top: 10rem;
    font-size: 2rem;
    animation: slideFromBelowDesktop 1s forwards;
  }
  p.text-center.text-lg-left.subText{
    font-size: 1.3rem;
    color: #B3B9CF;
    animation: slideFromBelowDesktop 1s forwards;
    font-family: "Prompt", sans-serif;
    font-weight: 300;
    font-style: normal;
  }
  div.justify-content-center.indicator-container {
    display: flex;
    justify-content: center;
    align-items: center; /* Added for vertical centering */
    background-color: #85899F80;
    width: 20%;
    padding: 0px 1px;
    border-radius: 5%;
    z-index: 1000;
    position: sticky;
    left: 50%;
    margin-top: 40vh;
    transform: translateX(-50%); /* Added for horizontal centering */
    min-height: 70px;
  }
  .dot-content {
    width: 10px; /* Adjust width and height as needed */
    height: 10px;
    border: 1px white solid; /* Optional for testing purposes, remove later */
    background-color: white; /* Avoids unexpected background */
    border-radius: 50%;
    margin: 25px 1.4rem;
  }
  div.dot {
    width: 5px; /*dot-content works, this not*/
    height: 5px;
    background-color: #A6ACC4;
    border-radius: 50%;
    margin: 0 8px;
  }
  .indicator-container > .dot.active {
    transform: scale(2);
  }

  a.dot.active div.dot-content{
    margin-left: 0.8rem;
    margin-right: 0.8rem;
  }

  
}























.navimage {
  width: 70%;
  max-width: 500px;
  height: auto;
  margin-bottom: 20px;
  margin-top: 40px;
}

.slideimage {
  position: absolute;
  left: 30%;
  bottom: -550px;
  margin-left: 40vw;
  opacity: 0;
  animation: slideFromLeft 1s forwards;
  z-index: -1;

}

.navcontainer {
  margin-top: 50px;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.navBar {
  display: flex;
  flex-direction: row;
  justify-content: center;
  z-index: 1;
}

.navItem {
  padding: 10px 50px; /* Default padding */
  text-decoration: none;
  color: white;
  font-size: 20px;
  font-weight: bold;
  transition: color 0.3s;
}

.fixedButton {
  position: absolute;
  bottom: 300px;
  left: 400px;
  width: 350px;
  height: 120px;
  background-color: #FC5404;
  border-radius: 5px;
  display: flex;
  justify-content: center;
  align-items: center;
  color: white;
  font-size: 25px;
  font-weight: bold;
  text-decoration: none;
  z-index: 2;
}

.activePoint {
  width: 10px;
  height: 10px;
  border-radius: 50%;
  background-color: #EEF1F6;
  margin: 0 5px;
  cursor: pointer;
  transition: background-color 0.3s;
}

.pointIndicator {
  position: absolute;
  bottom: 0;
  left: 50%;
  transform: translateX(-50%);
  display: flex;
  justify-content: center;
  align-items: center;
  margin-bottom: 20px;
  background-color: #85899F80;
  padding: 20px;
  border-radius: 18px;
  transition: transform 0.3s, background-color 0.3s;
}

.point {
  width: 10px;
  height: 10px;
  border-radius: 50%;
  background-color: gray;
  margin: 0 5px;
  cursor: pointer;
  transition: background-color 0.3s;
}
.activeNavItem {
  color: #FC5404;
  padding: 10px 50px;
  text-decoration: none;
  font-size: 20px;
  font-weight: bold;
  transition: color 0.3s;
}
/*--------------------------------------------------------------------Navbar END--------------------------------------------------------------------------------*/
/*--------------------------------------------------------------------Components--------------------------------------------------------------------------------*/

/*--------------------------------------------------------------------Components END--------------------------------------------------------------------------------*/
/*--------------------------------------------------------------------Footer--------------------------------------------------------------------------------*/

footer {
  flex-shrink: 0;
  display: table;
  margin: 100px auto 100px auto;
}

div#hyperlink-container {
  margin: 100px 5px 100px 5px;
  font-family: "Prompt", sans-serif;
  font-weight: 600;
  font-style: normal;
}


footer .copyright {
  color: #c5c5c5;
  width: 100%;
  z-index: 1000;

}

a.hyperlink{
  font-family: "Prompt", sans-serif;
  font-weight: 600;
  font-style: normal;
  font-size: 1.2rem;
  z-index: 1000;
}
a.hyperlink:hover{
  text-decoration: none;
  color: rgb(160, 84, 22);

}


footer .copyright p {
  font-family: "Unbounded";
  font-weight: 200;
  text-align: center;
  font-size: 1.4vw;
  margin-bottom: 50px;
}
/*--------------------------------------------------------------------Footer END--------------------------------------------------------------------------------*/

/*++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++PC END+++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++*/
/*++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++MOBILE+++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++*/

/* Media query for mobile devices */
@media only screen and (max-width: 768px) {
  html,
  body {
    margin: 0;
    padding: 0;
    height: 100%;
    overflow-x: hidden !important;

  }

/*--------------------------------------------------------------------Navbar--------------------------------------------------------------------------------*/

  .navcontainer {
    width: 100%;
    max-width: 100vw;
    margin: 0 auto;
  }

  .navimage {
    left: 10%; 
    margin-left: 0;
  }

  .navBar {
    align-items: center;
    margin: 0;
  }

  .navItem {
    padding: 40px 7px;
    margin: 0;
    font-size: 3.9vw;
  }

  .fixedButton {
    position: relative;
    bottom: auto;
    left: auto;
    margin-top: 300px; /*spacing between links and button */
    width: 300px;
    height: 80px;
  }
  .activeNavItem {
    padding: 10px 10px;
    font-size: 3.5vw;
  }
  /*--------------------------------------------------------------------Navbar END--------------------------------------------------------------------------------*/
/*--------------------------------------------------------------------Components--------------------------------------------------------------------------------*/

/*--------------------------------------------------------------------Components END--------------------------------------------------------------------------------*/
/*--------------------------------------------------------------------Footer--------------------------------------------------------------------------------*/
  footer {
    display: table;
    margin: 20px auto 50px auto;
  }
  footer .copyright {
    color: #c5c5c5;
    width: 100%;
    z-index: 1000;
  
  }

  footer .copyright p {
    font-size: 3.5vw;
    margin-bottom: 5px;
    z-index: 1000;

  }
  footer img {
    width: 200px;
    height: 50px;
    margin-bottom: 40px;
  }
  div#hyperlink-container {
    margin: 400px 20px 100px 20px;
  }
  
  a.hyperlink {
    text-align: center;
    margin: 0 40px;
    font-size: 60%;
    font-family: "Prompt", sans-serif;
    font-weight: 600;
    font-style: normal;
  }
  
  /*--------------------------------------------------------------------Footer End-----------------------------------------------------------------*/
}
/*++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++MOBILE END++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++*/
`, "",{"version":3,"sources":["webpack://./src/css/main.css"],"names":[],"mappings":"AAAA,gCAAgC;AAChC;EACE,0BAA0B;EAC1B,yDAAyD;EACzD,uDAAuD;EACvD,sDAAsD;EACtD,wDAAwD;EACxD,yDAAyD;EACzD,yDAAyD;EACzD,wDAAwD;EACxD,yDAAyD;AAC3D;;AAEA,qBAAqB;;AAErB;EACE,0CAA0C;AAC5C;;AAEA;EACE,oCAAoC;AACtC;AACA;EACE,oCAAoC;AACtC;AACA;EACE,mCAAmC;AACrC;AACA;EACE,mCAAmC;AACrC;AACA;EACE,mCAAmC;AACrC;AACA;EACE,mCAAmC;AACrC;AACA;EACE,mCAAmC;AACrC;AACA;EACE,mCAAmC;AACrC;;AAEA;EACE,SAAS;EACT,UAAU;EACV,sBAAsB;EACtB,qCAAqC;AACvC;;;AAGA;EACE,uBAAuB;EACvB,6BAA6B;EAC7B,uDAAuD;;AAEzD;AACA;EACE,SAAS;EACT,WAAW;EACX,YAAY;EACZ,oBAAoB;EACpB,uDAAuD;EACvD,2BAA2B;EAC3B,6BAA6B;AAC/B;;;AAGA;EACE,kBAAkB;EAClB,WAAW;EACX,uDAAuD;;AAEzD;;AAEA;EACE,mBAAmB;EACnB,+DAAuE;EACvE,mBAAmB;EACnB,kBAAkB;AACpB;AACA,8IAA8I;AAC9I,6JAA6J;AAC7J;EACE;IACE,gBAAgB;IAChB,mBAAmB;EACrB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,mBAAmB;IACnB,iBAAiB;EACnB;AACF;;AAEA;EACE;IACE,wBAAwB;EAC1B;EACA;IACE,0BAA0B;EAC5B;EACA;IACE,2BAA2B;EAC7B;AACF;;AAEA;EACE;IACE,UAAU;IACV,0BAA0B;EAC5B;EACA;IACE,UAAU;IACV,wBAAwB;;EAE1B;AACF;;AAEA;EACE;IACE,0BAA0B;IAC1B,UAAU;;EAEZ;EACA;IACE,2BAA2B;IAC3B,UAAU;;EAEZ;AACF;;AAEA;EACE;IACE,4BAA4B;IAC5B,UAAU;EACZ;EACA;IACE,2BAA2B;IAC3B,UAAU;EACZ;AACF;AACA;EACE;IACE,4BAA4B;IAC5B,UAAU;EACZ;EACA;IACE,0BAA0B;IAC1B,UAAU;EACZ;AACF;;AAEA;EACE,aAAa;EACb,iBAAiB;AACnB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,wCAAwC;EACxC,UAAU;AACZ;;AAEA;EACE,YAAY;EACZ,iBAAiB,EAAE,sBAAsB;EACzC,qBAAqB;EACrB,mBAAmB;EACnB,oBAAoB;EACpB,iCAAiC;EACjC,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;;EAEE,cAAc;EACd,gBAAgB;;AAElB;;AAEA;EACE;IACE,iBAAiB;IACjB,mBAAmB;IACnB,oBAAoB;EACtB;;EAEA;IACE,mBAAmB;IACnB,yBAAyB;IACzB,YAAY;IACZ,kBAAkB;IAClB,YAAY;IACZ,kBAAkB;IAClB,iBAAiB;IACjB,eAAe;IACf,eAAe;IACf,iCAAiC;IACjC,gBAAgB;IAChB,kBAAkB;IAClB,aAAa;EACf;;EAEA;IACE,kCAAkC;EACpC;EACA;IACE,aAAa;EACf;EACA;IACE,aAAa;EACf;;EAEA;IACE,kBAAkB;IAClB,SAAS;IACT,QAAQ;IACR,gCAAgC;IAChC,WAAW;IACX,gBAAgB;EAClB;EACA;IACE,kBAAkB;IAClB,UAAU;IACV,QAAQ;IACR,gCAAgC;IAChC,WAAW;IACX,gBAAgB;EAClB;EACA;IACE,kBAAkB;IAClB,UAAU;IACV,QAAQ;IACR,gCAAgC;IAChC,WAAW;IACX,gBAAgB;EAClB;EACA;IACE,kBAAkB;IAClB,SAAS;IACT,QAAQ;IACR,gCAAgC;IAChC,YAAY;IACZ,gBAAgB;IAChB,gBAAgB;EAClB;EACA;IACE,QAAQ;IACR,UAAU;IACV,kBAAkB;IAClB,mBAAmB;;EAErB;EACA;IACE,kBAAkB;IAClB,SAAS;IACT,OAAO;IACP,YAAY;IACZ,gBAAgB;EAClB;;EAEA;IACE,WAAW;IACX,SAAS;IACT,qCAAqC;IACrC,UAAU;IACV,iBAAiB;EACnB;EACA;IACE,WAAW;IACX,SAAS;IACT,qCAAqC;EACvC;EACA;IACE,WAAW;IACX,SAAS;IACT,qCAAqC;EACvC;EACA;IACE,SAAS;IACT,UAAU;EACZ;EACA;IACE,UAAU;IACV,UAAU;EACZ;;;EAGA;IACE,SAAS;IACT,UAAU;IACV,cAAc;IACd,kBAAkB;IAClB,UAAU;EACZ;EACA;IACE,SAAS;IACT,UAAU;IACV,kBAAkB;IAClB,eAAe;IACf,kBAAkB;IAClB,UAAU;EACZ;EACA;IACE,SAAS;IACT,mBAAmB;IACnB,UAAU;IACV,eAAe;EACjB;;;EAGA;IACE,kBAAkB;IAClB,YAAY;IACZ,YAAY;IACZ,UAAU;EACZ;EACA;IACE,kBAAkB;IAClB,YAAY;IACZ,YAAY;IACZ,UAAU;EACZ;EACA;IACE,kBAAkB;IAClB,WAAW;IACX,YAAY;IACZ,UAAU;EACZ;EACA;IACE,kBAAkB;IAClB,YAAY;IACZ,YAAY;IACZ,UAAU;EACZ;EACA;IACE,qCAAqC;IACrC,iBAAiB;IACjB,gBAAgB;IAChB,oCAAoC;IACpC,yBAAyB;IACzB,gBAAgB;IAChB,kBAAkB;EACpB;EACA;IACE,qCAAqC;IACrC,mBAAmB;IACnB,gBAAgB;IAChB,cAAc;IACd,iBAAiB;IACjB,gBAAgB;IAChB,YAAY;IACZ,iBAAiB;IACjB,kBAAkB;;EAEpB;EACA;IACE,aAAa;IACb,cAAc;IACd,qCAAqC;IACrC,mBAAmB;IACnB,aAAa;EACf;EACA;IACE,iBAAiB;IACjB,eAAe;IACf,qCAAqC;EACvC;EACA;IACE,aAAa;IACb,uBAAuB;IACvB,mBAAmB,EAAE,iCAAiC;IACtD,2BAA2B;IAC3B,UAAU;IACV,gBAAgB;IAChB,iBAAiB;IACjB,aAAa;IACb,kBAAkB;IAClB,QAAQ;IACR,SAAS;IACT,2BAA2B,EAAE,mCAAmC;IAChE,gBAAgB;EAClB;EACA;IACE,UAAU,EAAE,sCAAsC;IAClD,WAAW;IACX,uBAAuB,EAAE,gDAAgD;IACzE,uBAAuB,EAAE,iCAAiC;IAC1D,kBAAkB;IAClB,mBAAmB;EACrB;EACA;IACE,UAAU,EAAE,8BAA8B;IAC1C,WAAW;IACX,yBAAyB;IACzB,kBAAkB;IAClB,aAAa;EACf;EACA;IACE,mBAAmB;EACrB;;EAEA;IACE,mBAAmB;IACnB,oBAAoB;EACtB;;;;AAIF;AACA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,mBAAmB;EACnB,iCAAiC,EAAE,mCAAmC;AACxE;;AAEA;EACE;IACE,aAAa;IACb,+BAA+B;EACjC;;EAEA;IACE,iBAAiB;IACjB,gBAAgB;IAChB,iBAAiB;EACnB;;EAEA,6CAA6C;EAC7C;IACE,cAAc,EAAE,2CAA2C;EAC7D;EACA;IACE,kBAAkB;IAClB,kBAAkB;IAClB,mBAAmB;IACnB,iCAAiC,EAAE,mCAAmC;EACxE;;EAEA;IACE,yBAAyB;IACzB,YAAY;IACZ,kBAAkB;IAClB,YAAY;IACZ,kBAAkB;IAClB,iBAAiB;IACjB,eAAe;IACf,iBAAiB;IACjB,iCAAiC;IACjC,gBAAgB;IAChB,kBAAkB;IAClB,aAAa;EACf;;EAEA;IACE,kCAAkC;EACpC;;EAEA;IACE,mBAAmB;IACnB,iBAAiB;EACnB;EACA;IACE,kBAAkB;IAClB,kBAAkB;IAClB,WAAW;IACX,UAAU;IACV,2CAA2C;EAC7C;EACA;IACE,kBAAkB;IAClB,UAAU;IACV,SAAS;EACX;EACA;IACE,kBAAkB;IAClB,UAAU;IACV,SAAS;EACX;EACA;IACE,SAAS;IACT,UAAU;EACZ;EACA;IACE,QAAQ;EACV;EACA;IACE,UAAU;IACV,UAAU;EACZ;EACA;IACE,WAAW;EACb;EACA;IACE,UAAU;IACV,WAAW;EACb;EACA;IACE,SAAS;IACT,UAAU;EACZ;EACA;IACE,UAAU;IACV,UAAU;EACZ;;EAEA;IACE,UAAU;IACV,UAAU;IACV,UAAU;IACV,gBAAgB;EAClB;EACA;IACE,UAAU;IACV,UAAU;IACV,eAAe;EACjB;EACA;IACE,UAAU;IACV,UAAU;IACV,eAAe;EACjB;EACA;IACE,YAAY;IACZ,YAAY;IACZ,SAAS;IACT,UAAU;EACZ;EACA;IACE,SAAS;IACT,YAAY;IACZ,YAAY;EACd;EACA;IACE,YAAY;IACZ,SAAS;IACT,YAAY;EACd;EACA;IACE,YAAY;IACZ,SAAS;IACT,YAAY;EACd;;EAEA;IACE,4CAA4C;IAC5C,oCAAoC;IACpC,yBAAyB;IACzB,gBAAgB;IAChB,kBAAkB;IAClB,iBAAiB;EACnB;EACA;IACE,oCAAoC;IACpC,gBAAgB;IAChB,kBAAkB;EACpB;;;EAGA;IACE,aAAa;IACb,cAAc;IACd,4CAA4C;IAC5C,gBAAgB;EAClB;EACA;IACE,iBAAiB;IACjB,eAAe;IACf,4CAA4C;EAC9C;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,4CAA4C;IAC5C,iCAAiC;IACjC,gBAAgB;IAChB,kBAAkB;EACpB;EACA;IACE,aAAa;IACb,uBAAuB;IACvB,mBAAmB,EAAE,iCAAiC;IACtD,2BAA2B;IAC3B,UAAU;IACV,gBAAgB;IAChB,iBAAiB;IACjB,aAAa;IACb,gBAAgB;IAChB,SAAS;IACT,gBAAgB;IAChB,2BAA2B,EAAE,mCAAmC;IAChE,gBAAgB;EAClB;EACA;IACE,WAAW,EAAE,sCAAsC;IACnD,YAAY;IACZ,uBAAuB,EAAE,gDAAgD;IACzE,uBAAuB,EAAE,iCAAiC;IAC1D,kBAAkB;IAClB,mBAAmB;EACrB;EACA;IACE,UAAU,EAAE,8BAA8B;IAC1C,WAAW;IACX,yBAAyB;IACzB,kBAAkB;IAClB,aAAa;EACf;EACA;IACE,mBAAmB;EACrB;;EAEA;IACE,mBAAmB;IACnB,oBAAoB;EACtB;;;AAGF;;;;;;;;;;;;;;;;;;;;;;;;AAwBA;EACE,UAAU;EACV,gBAAgB;EAChB,YAAY;EACZ,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,cAAc;EACd,iBAAiB;EACjB,UAAU;EACV,oCAAoC;EACpC,WAAW;;AAEb;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,UAAU;AACZ;;AAEA;EACE,kBAAkB,EAAE,oBAAoB;EACxC,qBAAqB;EACrB,YAAY;EACZ,eAAe;EACf,iBAAiB;EACjB,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,WAAW;EACX,YAAY;EACZ,aAAa;EACb,yBAAyB;EACzB,kBAAkB;EAClB,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,YAAY;EACZ,eAAe;EACf,iBAAiB;EACjB,qBAAqB;EACrB,UAAU;AACZ;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,yBAAyB;EACzB,aAAa;EACb,eAAe;EACf,iCAAiC;AACnC;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,SAAS;EACT,2BAA2B;EAC3B,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,mBAAmB;EACnB,2BAA2B;EAC3B,aAAa;EACb,mBAAmB;EACnB,iDAAiD;AACnD;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,sBAAsB;EACtB,aAAa;EACb,eAAe;EACf,iCAAiC;AACnC;AACA;EACE,cAAc;EACd,kBAAkB;EAClB,qBAAqB;EACrB,eAAe;EACf,iBAAiB;EACjB,sBAAsB;AACxB;AACA,iKAAiK;AACjK,iKAAiK;;AAEjK,qKAAqK;AACrK,6JAA6J;;AAE7J;EACE,cAAc;EACd,cAAc;EACd,6BAA6B;AAC/B;;AAEA;EACE,2BAA2B;EAC3B,iCAAiC;EACjC,gBAAgB;EAChB,kBAAkB;AACpB;;;AAGA;EACE,cAAc;EACd,WAAW;EACX,aAAa;;AAEf;;AAEA;EACE,iCAAiC;EACjC,gBAAgB;EAChB,kBAAkB;EAClB,iBAAiB;EACjB,aAAa;AACf;AACA;EACE,qBAAqB;EACrB,uBAAuB;;AAEzB;;;AAGA;EACE,wBAAwB;EACxB,gBAAgB;EAChB,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;AACrB;AACA,iKAAiK;;AAEjK,kJAAkJ;AAClJ,kJAAkJ;;AAElJ,mCAAmC;AACnC;EACE;;IAEE,SAAS;IACT,UAAU;IACV,YAAY;IACZ,6BAA6B;;EAE/B;;AAEF,6JAA6J;;EAE3J;IACE,WAAW;IACX,gBAAgB;IAChB,cAAc;EAChB;;EAEA;IACE,SAAS;IACT,cAAc;EAChB;;EAEA;IACE,mBAAmB;IACnB,SAAS;EACX;;EAEA;IACE,iBAAiB;IACjB,SAAS;IACT,gBAAgB;EAClB;;EAEA;IACE,kBAAkB;IAClB,YAAY;IACZ,UAAU;IACV,iBAAiB,EAAE,oCAAoC;IACvD,YAAY;IACZ,YAAY;EACd;EACA;IACE,kBAAkB;IAClB,gBAAgB;EAClB;EACA,iKAAiK;AACnK,iKAAiK;;AAEjK,qKAAqK;AACrK,6JAA6J;EAC3J;IACE,cAAc;IACd,2BAA2B;EAC7B;EACA;IACE,cAAc;IACd,WAAW;IACX,aAAa;;EAEf;;EAEA;IACE,gBAAgB;IAChB,kBAAkB;IAClB,aAAa;;EAEf;EACA;IACE,YAAY;IACZ,YAAY;IACZ,mBAAmB;EACrB;EACA;IACE,6BAA6B;EAC/B;;EAEA;IACE,kBAAkB;IAClB,cAAc;IACd,cAAc;IACd,iCAAiC;IACjC,gBAAgB;IAChB,kBAAkB;EACpB;;EAEA,kJAAkJ;AACpJ;AACA,qJAAqJ","sourcesContent":["/* Global variables definition */\n:root {\n  /* Responsive font sizes */\n  --step--2: clamp(0.69rem, calc(0.66rem + 0.18vw), 0.8rem);\n  --step--1: clamp(0.83rem, calc(0.78rem + 0.29vw), 1rem);\n  --step-0: clamp(1rem, calc(0.91rem + 0.43vw), 1.25rem);\n  --step-1: clamp(1.2rem, calc(1.07rem + 0.63vw), 1.56rem);\n  --step-2: clamp(1.44rem, calc(1.26rem + 0.89vw), 1.95rem);\n  --step-3: clamp(1.73rem, calc(1.48rem + 1.24vw), 2.44rem);\n  --step-4: clamp(2.07rem, calc(1.73rem + 1.7vw), 3.05rem);\n  --step-5: clamp(2.49rem, calc(2.03rem + 2.31vw), 3.82rem);\n}\n\n/* Reusable classes */\n\n.ff-nord {\n  font-family: \"Nord\", sans-serif !important;\n}\n\n.font--2 {\n  font-size: var(--step--2) !important;\n}\n.font--1 {\n  font-size: var(--step--1) !important;\n}\n.font-0 {\n  font-size: var(--step-0) !important;\n}\n.font-1 {\n  font-size: var(--step-1) !important;\n}\n.font-2 {\n  font-size: var(--step-2) !important;\n}\n.font-3 {\n  font-size: var(--step-3) !important;\n}\n.font-4 {\n  font-size: var(--step-4) !important;\n}\n.font-5 {\n  font-size: var(--step-5) !important;\n}\n\n* {\n  margin: 0;\n  padding: 0;\n  box-sizing: border-box;\n  font-family: \"Montserrat\", sans-serif;\n}\n\n\nhtml {\n  scroll-behavior: smooth;\n  overflow-x: hidden !important;\n  background: linear-gradient(to right, #12121E, #242424);\n\n}\nbody {\n  zoom: 65%;\n  width: 100%;\n  height: 100%;\n  font-family: poppins;\n  background: linear-gradient(to right, #12121E, #242424);\n  background-position: center;\n  overflow-x: hidden !important;\n}\n\n\n.App {\n  overflow-x: hidden;\n  width: 100%;\n  background: linear-gradient(to right, #12121E, #242424);\n\n}\n\n@font-face {\n  font-family: \"Nord\";\n  src: url(\"../../public/static/fonts/Nord-Light.ttf\") format(\"truetype\");\n  font-weight: normal;\n  font-style: normal;\n}\n/*++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++PC+++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++*/\n/*--------------------------------------------------------------------Navbar--------------------------------------------------------------------------------*/\n@keyframes scrolling {\n  0% {\n    overflow: hidden;\n    animation-delay: 4s;\n  }\n  50% {\n    animation-delay: 4s;\n  }\n  100% {\n    animation-delay: 4s;\n    overflow: visible;\n  }\n}\n\n@keyframes gradientMove {\n  0% {\n    background-position: 0 0;\n  }\n  50% {\n    background-position: 0 50%;\n  }\n  100% {\n    background-position: 100% 0;\n  }\n}\n\n@keyframes slideFromBelow {\n  0% {\n    opacity: 0;\n    transform: translateY(50%);\n  }\n  100% {\n    opacity: 1;\n    transform: translateY(0);\n\n  }\n}\n\n@keyframes slideFromBelowDesktop {\n  0% {\n    transform: translateY(50%);\n    opacity: 0;\n\n  }\n  100% {\n    transform: translateY(-50%);\n    opacity: 1;\n\n  }\n}\n\n@keyframes slideFromLeft {\n  0% {\n    transform: translateX(-100%);\n    opacity: 0;\n  }\n  100% {\n    transform: translateX(-20%);\n    opacity: 1;\n  }\n}\n@keyframes slideFromLeftDesktop {\n  0% {\n    transform: translateX(-100%);\n    opacity: 0;\n  }\n  100% {\n    transform: translateX(90%);\n    opacity: 1;\n  }\n}\n\n.navbar-nav {\n  display: flex;\n  flex-wrap: nowrap;\n}\n\n.nav-item {\n  padding: 0 10px;\n}\n\n.navbar-custom {\n  background-color: transparent !important;\n  z-index: 2;\n}\n\n.navbar-custom .navbar-brand-custom {\n  color: white;\n  font-size: 1.5rem; /* Default font size */\n  text-decoration: none;\n  margin-left: 1.4rem;\n  margin-right: 1.4rem;\n  font-family: \"Prompt\", sans-serif;\n  font-weight: 300;\n  font-style: normal;\n}\n\n.navbar-custom .navbar-brand-custom:hover,\n.navbar-custom .navbar-brand-custom.active {\n  color: #FC5404;\n  font-weight: 600;\n\n}\n\n@media (max-width: 768px) {\n  .navbar-custom .navbar-brand-custom {\n    font-size: 0.8rem;\n    margin-left: 0.8rem;\n    margin-right: 0.8rem;\n  }\n\n  button.btn-orange {\n    margin-bottom: 30px;\n    background-color: #FC5404;\n    color: white;\n    padding: 13px 30px;\n    border: none;\n    border-radius: 5px;\n    font-weight: bold;\n    cursor: pointer;\n    font-size: 1rem;\n    font-family: \"Prompt\", sans-serif;\n    font-weight: 500;\n    font-style: normal;\n    z-index: 1000;\n  }\n  \n  .btn-orange:hover {\n    background-color: rgb(160, 84, 22);\n  }\n  .social-buttons{\n    z-index: 1000;\n  }\n  img.socialLogo{\n    z-index: 1000;\n  }\n\n  .animated-image-container {\n    position: absolute;\n    left: 23%;\n    top: 30%;\n    transform: translate(-50%, -50%);\n    width: 80vw;\n    max-width: 300px;\n  }\n  .animated-image-container-knowledge {\n    position: absolute;\n    left: -20%;\n    top: 30%;\n    transform: translate(-50%, -50%);\n    width: 80vw;\n    max-width: 300px;\n  }\n  .animated-image-container-insights {\n    position: absolute;\n    left: -20%;\n    top: 30%;\n    transform: translate(-50%, -50%);\n    width: 80vw;\n    max-width: 300px;\n  }\n  .animated-image-container-simplicity {\n    position: absolute;\n    left: 40%;\n    top: 30%;\n    transform: translate(-50%, -50%);\n    width: 160vw;\n    max-width: 600px;\n    margin-left: 10%;\n  }\n  .animated-image-container-decode {\n    top: 10%;\n    left: -10%;\n    position: relative;\n    margin-bottom: 70vh;\n\n  }\n  .animated-image-container-empower {\n    position: absolute;\n    left: -5%;\n    top: 1%;\n    width: 135vw;\n    max-width: 600px;\n  }\n\n  .animated-image {\n    width: 210%;\n    left: 50%;\n    animation: slideFromBelow 1s forwards;\n    z-index: 2;\n    margin-top: -50px;\n  }\n  img.animated-image.image-knowledge{\n    width: 400%;\n    left: 25%;\n    animation: slideFromBelow 1s forwards;\n  }\n  img.animated-image.image-insights{\n    width: 400%;\n    left: 20%;\n    animation: slideFromBelow 1s forwards;\n  }\n  img.animated-image.image-simplicity{\n    left: 20%;\n    width: 50%;\n  }\n  img.animated-image.image-simplicity2{\n    left: 140%;\n    width: 40%;\n  }\n\n\n  .image-empower{\n    left: 23%;\n    width: 70%;\n    margin-top: 9%;\n    position: absolute;\n    z-index: 2;   \n  }\n  .image-empower2{\n    left: 50%;\n    width: 50%;\n    margin-left: 100px;\n    margin-top: 35%;\n    position: absolute; \n    z-index: 1; \n  }\n  .image-empower3{\n    left: 60%;\n    margin-right: 500px;\n    width: 50%;\n    margin-top: 35%;\n  }\n\n\n  .image-decode{\n    position: absolute;\n    left: -12rem;\n    width: 50rem;\n    top: -4rem;\n  }\n  .image-decode2{\n    position: absolute;\n    left: -14rem;\n    width: 50rem;\n    top: -4rem;\n  }\n  .image-decode3{\n    position: absolute;\n    left: -9rem;\n    width: 50rem;\n    top: -5rem;\n  }\n  .image-decode4{\n    position: absolute;\n    left: -12rem;\n    width: 50rem;\n    top: -4rem;\n  }\n  h1.text-center.text-lg-left.font-weight-bold.text-white{\n    animation: slideFromBelow 1s forwards;\n    font-size: 1.3rem;\n    margin-top: 50px;\n    font-family: \"Unbounded\", sans-serif;\n    font-optical-sizing: auto;\n    font-weight: 600;\n    font-style: normal;\n  }\n  p.text-center.text-lg-left.subText{\n    animation: slideFromBelow 1s forwards;\n    margin-bottom: 30px;\n    margin-top: 15px;\n    color: #B3B9CF;\n    font-size: 0.9rem;\n    font-weight: 700;\n    width: 420px;\n    margin-left: auto;\n    margin-right: auto;\n\n  }\n  .socialLogo{\n    width: 3.1rem;\n    height: 3.1rem;\n    animation: slideFromBelow 1s forwards;\n    margin-bottom: 50px;\n    z-index: 1000;\n  }\n  .socialText{\n    margin-top: 100px;\n    font-size: 1rem;\n    animation: slideFromBelow 1s forwards;\n  }\n  div.justify-content-center.indicator-container {\n    display: flex;\n    justify-content: center;\n    align-items: center; /* Added for vertical centering */\n    background-color: #85899F80;\n    width: 65%;\n    padding: 0px 1px;\n    border-radius: 6%;\n    z-index: 1000;\n    position: absolute;\n    top: 95%;\n    left: 50%;\n    transform: translateX(-50%); /* Added for horizontal centering */\n    min-height: 20px;\n  }\n  .dot-content {\n    width: 8px; /* Adjust width and height as needed */\n    height: 8px;\n    border: 1px white solid; /* Optional for testing purposes, remove later */\n    background-color: white; /* Avoids unexpected background */\n    border-radius: 50%;\n    margin: 15px 0.9rem;\n  }\n  div.dot {\n    width: 5px; /*dot-content works, this not*/\n    height: 5px;\n    background-color: #A6ACC4;\n    border-radius: 50%;\n    margin: 0 8px;\n  }\n  .indicator-container > .dot.active {\n    transform: scale(2);\n  }\n\n  a.dot.active div.dot-content{\n    margin-left: 0.8rem;\n    margin-right: 0.8rem;\n  }\n\n\n  \n}\n.root-container {\n  overflow-x: scroll;\n  overflow-y: hidden;\n  white-space: nowrap;\n  -webkit-overflow-scrolling: touch; /* Enable smooth scrolling on iOS */\n}\n\n@media (min-width: 768px) {\n  .container {\n    display: flex;\n    transition: transform 0.5s ease;\n  }\n\n  .navbar-custom .navbar-brand-custom {\n    font-size: 1.8rem;\n    margin-left: 4vw;\n    margin-right: 4vw;\n  }\n  \n  /* Adjust the positioning of the components */\n  .container > div {\n    flex: 0 0 100%; /* Ensure each component takes full width */\n  }\n  .root-container {\n    overflow-x: scroll;\n    overflow-y: hidden;\n    white-space: nowrap;\n    -webkit-overflow-scrolling: touch; /* Enable smooth scrolling on iOS */\n  }\n  \n  button.btn-orange {\n    background-color: #FC5404;\n    color: white;\n    padding: 13px 30px;\n    border: none;\n    border-radius: 5px;\n    font-weight: bold;\n    cursor: pointer;\n    font-size: 1.5rem;\n    font-family: \"Prompt\", sans-serif;\n    font-weight: 500;\n    font-style: normal;\n    z-index: 1000;\n  }\n  \n  .btn-orange:hover {\n    background-color: rgb(160, 84, 22);\n  }\n\n  .col-lg-8.offset-lg-2 {\n    margin-left: -25rem;\n    margin-top: 12rem;\n  }\n  .animated-image {\n    margin-top: -35rem;\n    position: absolute;\n    width: 135%;\n    left: -10%;\n    animation: slideFromLeftDesktop 1s forwards;\n  }\n  .animated-image-container-knowledge {\n    position: absolute;\n    left: -80%;\n    top: -15%;\n  }\n  .animated-image-container-insights {\n    position: absolute;\n    left: -60%;\n    top: -25%;\n  }\n  .animated-image-container-decode {\n    top: -20%;\n    left: -50%;\n  }\n  .animated-image-container-simplicity {\n    top: 20%;\n  }\n  .animated-image-container-empower {\n    top: -100%;\n    left: -35%;\n  }\n  .image-knowledge{\n    width: 190%;\n  }\n  .image-insights{\n    left: -20%;\n    width: 170%;\n  }\n  .image-simplicity{\n    left: 80%;\n    width: 50%;\n  }\n  .image-simplicity2{\n    left: 140%;\n    width: 40%;\n  }\n\n  .image-empower{\n    left: 120%;\n    width: 60%;\n    z-index: 3;\n    margin-top: -15%;\n  }\n  .image-empower2{\n    left: 160%;\n    width: 50%;\n    margin-top: -1%;\n  }\n  .image-empower3{\n    left: 110%;\n    width: 50%;\n    margin-top: -1%;\n  }\n  .image-decode{\n    left: -15rem;\n    width: 90rem;\n    top: 7rem;\n    z-index: 3;\n  }\n  .image-decode2{\n    top: 9rem;\n    left: -19rem;\n    width: 90rem;\n  }\n  .image-decode3{\n    left: -10rem;\n    top: 5rem;\n    width: 90rem;\n  }\n  .image-decode4{\n    left: -14rem;\n    top: 7rem;\n    width: 90rem;\n  }\n\n  h1.text-center.text-lg-left.font-weight-bold.text-white{\n    animation: slideFromBelowDesktop 1s forwards;\n    font-family: \"Unbounded\", sans-serif;\n    font-optical-sizing: auto;\n    font-weight: 600;\n    font-style: normal;\n    font-size: 2.1rem;\n  }\n  h2.text-center.mb-4.font-weight-bold.text-white.socialText{\n    font-family: \"Unbounded\", sans-serif;\n    font-weight: 600;\n    font-style: normal;\n  }\n\n\n  .socialLogo{\n    width: 4.5rem;\n    height: 4.5rem;\n    animation: slideFromBelowDesktop 1s forwards;\n    margin-top: 5rem;\n  }\n  .socialText{\n    margin-top: 10rem;\n    font-size: 2rem;\n    animation: slideFromBelowDesktop 1s forwards;\n  }\n  p.text-center.text-lg-left.subText{\n    font-size: 1.3rem;\n    color: #B3B9CF;\n    animation: slideFromBelowDesktop 1s forwards;\n    font-family: \"Prompt\", sans-serif;\n    font-weight: 300;\n    font-style: normal;\n  }\n  div.justify-content-center.indicator-container {\n    display: flex;\n    justify-content: center;\n    align-items: center; /* Added for vertical centering */\n    background-color: #85899F80;\n    width: 20%;\n    padding: 0px 1px;\n    border-radius: 5%;\n    z-index: 1000;\n    position: sticky;\n    left: 50%;\n    margin-top: 40vh;\n    transform: translateX(-50%); /* Added for horizontal centering */\n    min-height: 70px;\n  }\n  .dot-content {\n    width: 10px; /* Adjust width and height as needed */\n    height: 10px;\n    border: 1px white solid; /* Optional for testing purposes, remove later */\n    background-color: white; /* Avoids unexpected background */\n    border-radius: 50%;\n    margin: 25px 1.4rem;\n  }\n  div.dot {\n    width: 5px; /*dot-content works, this not*/\n    height: 5px;\n    background-color: #A6ACC4;\n    border-radius: 50%;\n    margin: 0 8px;\n  }\n  .indicator-container > .dot.active {\n    transform: scale(2);\n  }\n\n  a.dot.active div.dot-content{\n    margin-left: 0.8rem;\n    margin-right: 0.8rem;\n  }\n\n  \n}\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n.navimage {\n  width: 70%;\n  max-width: 500px;\n  height: auto;\n  margin-bottom: 20px;\n  margin-top: 40px;\n}\n\n.slideimage {\n  position: absolute;\n  left: 30%;\n  bottom: -550px;\n  margin-left: 40vw;\n  opacity: 0;\n  animation: slideFromLeft 1s forwards;\n  z-index: -1;\n\n}\n\n.navcontainer {\n  margin-top: 50px;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n}\n\n.navBar {\n  display: flex;\n  flex-direction: row;\n  justify-content: center;\n  z-index: 1;\n}\n\n.navItem {\n  padding: 10px 50px; /* Default padding */\n  text-decoration: none;\n  color: white;\n  font-size: 20px;\n  font-weight: bold;\n  transition: color 0.3s;\n}\n\n.fixedButton {\n  position: absolute;\n  bottom: 300px;\n  left: 400px;\n  width: 350px;\n  height: 120px;\n  background-color: #FC5404;\n  border-radius: 5px;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  color: white;\n  font-size: 25px;\n  font-weight: bold;\n  text-decoration: none;\n  z-index: 2;\n}\n\n.activePoint {\n  width: 10px;\n  height: 10px;\n  border-radius: 50%;\n  background-color: #EEF1F6;\n  margin: 0 5px;\n  cursor: pointer;\n  transition: background-color 0.3s;\n}\n\n.pointIndicator {\n  position: absolute;\n  bottom: 0;\n  left: 50%;\n  transform: translateX(-50%);\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  margin-bottom: 20px;\n  background-color: #85899F80;\n  padding: 20px;\n  border-radius: 18px;\n  transition: transform 0.3s, background-color 0.3s;\n}\n\n.point {\n  width: 10px;\n  height: 10px;\n  border-radius: 50%;\n  background-color: gray;\n  margin: 0 5px;\n  cursor: pointer;\n  transition: background-color 0.3s;\n}\n.activeNavItem {\n  color: #FC5404;\n  padding: 10px 50px;\n  text-decoration: none;\n  font-size: 20px;\n  font-weight: bold;\n  transition: color 0.3s;\n}\n/*--------------------------------------------------------------------Navbar END--------------------------------------------------------------------------------*/\n/*--------------------------------------------------------------------Components--------------------------------------------------------------------------------*/\n\n/*--------------------------------------------------------------------Components END--------------------------------------------------------------------------------*/\n/*--------------------------------------------------------------------Footer--------------------------------------------------------------------------------*/\n\nfooter {\n  flex-shrink: 0;\n  display: table;\n  margin: 100px auto 100px auto;\n}\n\ndiv#hyperlink-container {\n  margin: 100px 5px 100px 5px;\n  font-family: \"Prompt\", sans-serif;\n  font-weight: 600;\n  font-style: normal;\n}\n\n\nfooter .copyright {\n  color: #c5c5c5;\n  width: 100%;\n  z-index: 1000;\n\n}\n\na.hyperlink{\n  font-family: \"Prompt\", sans-serif;\n  font-weight: 600;\n  font-style: normal;\n  font-size: 1.2rem;\n  z-index: 1000;\n}\na.hyperlink:hover{\n  text-decoration: none;\n  color: rgb(160, 84, 22);\n\n}\n\n\nfooter .copyright p {\n  font-family: \"Unbounded\";\n  font-weight: 200;\n  text-align: center;\n  font-size: 1.4vw;\n  margin-bottom: 50px;\n}\n/*--------------------------------------------------------------------Footer END--------------------------------------------------------------------------------*/\n\n/*++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++PC END+++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++*/\n/*++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++MOBILE+++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++*/\n\n/* Media query for mobile devices */\n@media only screen and (max-width: 768px) {\n  html,\n  body {\n    margin: 0;\n    padding: 0;\n    height: 100%;\n    overflow-x: hidden !important;\n\n  }\n\n/*--------------------------------------------------------------------Navbar--------------------------------------------------------------------------------*/\n\n  .navcontainer {\n    width: 100%;\n    max-width: 100vw;\n    margin: 0 auto;\n  }\n\n  .navimage {\n    left: 10%; \n    margin-left: 0;\n  }\n\n  .navBar {\n    align-items: center;\n    margin: 0;\n  }\n\n  .navItem {\n    padding: 40px 7px;\n    margin: 0;\n    font-size: 3.9vw;\n  }\n\n  .fixedButton {\n    position: relative;\n    bottom: auto;\n    left: auto;\n    margin-top: 300px; /*spacing between links and button */\n    width: 300px;\n    height: 80px;\n  }\n  .activeNavItem {\n    padding: 10px 10px;\n    font-size: 3.5vw;\n  }\n  /*--------------------------------------------------------------------Navbar END--------------------------------------------------------------------------------*/\n/*--------------------------------------------------------------------Components--------------------------------------------------------------------------------*/\n\n/*--------------------------------------------------------------------Components END--------------------------------------------------------------------------------*/\n/*--------------------------------------------------------------------Footer--------------------------------------------------------------------------------*/\n  footer {\n    display: table;\n    margin: 20px auto 50px auto;\n  }\n  footer .copyright {\n    color: #c5c5c5;\n    width: 100%;\n    z-index: 1000;\n  \n  }\n\n  footer .copyright p {\n    font-size: 3.5vw;\n    margin-bottom: 5px;\n    z-index: 1000;\n\n  }\n  footer img {\n    width: 200px;\n    height: 50px;\n    margin-bottom: 40px;\n  }\n  div#hyperlink-container {\n    margin: 400px 20px 100px 20px;\n  }\n  \n  a.hyperlink {\n    text-align: center;\n    margin: 0 40px;\n    font-size: 60%;\n    font-family: \"Prompt\", sans-serif;\n    font-weight: 600;\n    font-style: normal;\n  }\n  \n  /*--------------------------------------------------------------------Footer End-----------------------------------------------------------------*/\n}\n/*++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++MOBILE END++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++*/\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
